import React from 'react';
import './Snowfall.css';

const Snowfall = () => {
  // Generate 20 snowflakes with random properties
  const snowflakes = Array.from({ length: 20 }, (_, i) => {
    const size = Math.random() * 6 + 2;
    const left = Math.random() * 100;
    const delay = Math.random() * 15;
    const duration = Math.random() * 10 + 8;
    const opacity = Math.random() * 0.6 + 0.2;
    const drift = Math.random() * 40 - 20;

    return (
      <div
        key={i}
        className="snowflake"
        style={{
          width: `${size}px`,
          height: `${size}px`,
          left: `${left}%`,
          animationDelay: `${delay}s`,
          animationDuration: `${duration}s`,
          opacity: opacity,
          '--drift': `${drift}px`,
        }}
      />
    );
  });

  return <div className="snowfall-container">{snowflakes}</div>;
};

export default Snowfall;
